import { FilterMatchMode } from "primereact/api";

export class Inversion {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            pais: {
                value: null,
                export: false,
                table: false,
                header: 'PAÍS DONDE SE LOCALIZA LA INVERSIÓN:',
                required: 'País es requerido',
            },
            tipo_inversion: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de Inversión:',
                required: 'Tipo de Inversión es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            otra_inversion: {
                value: '',
                export: false,
                table: false,
                header: 'OTRA INVERSIÓN:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            institucion: {
                value: '',
                export: false,
                table: true,
                header: 'INSTITUCIÓN DONDE SE REALIZA LA INVERSIÓN:',
                required: 'Institución es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            fecha_inversion: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'FECHA DE INVERSIÓN:',
                required: 'Fecha de inversión es requerida',
            },
            monto: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'MONTO DE LA INVERSIÓN USD:',
                required: 'Valor es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
